/**
 * This file was auto-generated.
 * Do not make direct changes to the file.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { z } from 'zod'

import * as CommonTypes from './common-types'

export const AnalyticsInterval = {
	Day: 'day',
	Week: 'week',
	Month: 'month',
	Quarter: 'quarter',
	Year: 'year'
} as const
export type AnalyticsIntervalType = (typeof AnalyticsInterval)[keyof typeof AnalyticsInterval]
export type PeriodMetrics = {
	revenue: CommonTypes.Amount
	orderCount: number
	averageOrderValue: CommonTypes.Amount
	refundTotal: CommonTypes.Amount
	refundCount: number
}
export type ComparisonRange = {
	from: number
	to: number
}
export type AnalyticsOverviewResponse = {
	currentPeriod: PeriodMetrics
	previousPeriod: PeriodMetrics
	comparisonRange: ComparisonRange
	currencyCode: string
	hasComparison: boolean
}
export type RevenueOverTimeDataPoint = {
	date: string
	revenue: CommonTypes.Amount
	orderCount: number
	averageOrderValue: CommonTypes.Amount
	refundTotal: CommonTypes.Amount
	partial: boolean
}
export type TopProductItem = {
	productUuid: string
	productTitle: string
	imageUrl: string | null
	revenue: CommonTypes.Amount
	quantity: number
	orderCount: number
}
export type PaymentMethodItem = {
	method: string
	cardType: string | null
	amount: CommonTypes.Amount
	count: number
	percentage: number
}
export type SalesChannelItem = {
	salesChannelUuid: string | null
	name: string
	revenue: CommonTypes.Amount
	orderCount: number
}
export type PointOfSaleItem = {
	pointOfSaleUuid: string | null
	name: string
	revenue: CommonTypes.Amount
	orderCount: number
}
export type SalesByChannelResponse = {
	channels: SalesChannelItem[]
	pointsOfSale: PointOfSaleItem[]
}
export type HourlyDistributionItem = {
	hour: number
	orderCount: number
	revenue: CommonTypes.Amount
}
export type CategoryItem = {
	categoryUuid: string | null
	categoryName: string
	revenue: CommonTypes.Amount
	orderCount: number
	percentage: number
}
export type AnalyticsResponse = {
	overview: AnalyticsOverviewResponse
	revenueOverTime: RevenueOverTimeDataPoint[]
	comparisonOverTime?: RevenueOverTimeDataPoint[]
	topProducts: TopProductItem[]
	topProductsByQuantity: TopProductItem[]
	paymentMethods: PaymentMethodItem[]
	salesByChannel: SalesByChannelResponse
	hourlyDistribution: HourlyDistributionItem[]
	categories: CategoryItem[]
	periodStart: number
	periodEnd: number
	isCurrentPeriod: boolean
	channelFilterActive: boolean
}
export const BasketPairSortField = {
	Cooccurrencecount: 'coOccurrenceCount',
	Support: 'support',
	Confidence: 'confidence',
	Lift: 'lift'
} as const
export type BasketPairSortFieldType = (typeof BasketPairSortField)[keyof typeof BasketPairSortField]
export const BasketSortOrder = {
	Asc: 'asc',
	Desc: 'desc'
} as const
export type BasketSortOrderType = (typeof BasketSortOrder)[keyof typeof BasketSortOrder]
export type BasketOverviewPeriod = {
	avgItemsPerOrder: number
	avgUniqueProductsPerOrder: number
	orderCount: number
}
export type BasketOverviewResponse = {
	currentPeriod: BasketOverviewPeriod
	previousPeriod: BasketOverviewPeriod
	comparisonRange: ComparisonRange
}
export type ProductPairItem = {
	productAUuid: string
	productATitle: string
	productAImageUrl: string | null
	productBUuid: string
	productBTitle: string
	productBImageUrl: string | null
	coOccurrenceCount: number
	support: number
	confidence: number
	lift: number
}
export type CategoryPairItem = {
	categoryAUuid: string | null
	categoryAName: string
	categoryBUuid: string | null
	categoryBName: string
	coOccurrenceCount: number
	support: number
	confidence: number
	lift: number
}
export type BasketAnalysisResponse = {
	overview: BasketOverviewResponse
	productPairs: ProductPairItem[]
	categoryPairs: CategoryPairItem[]
}
export type UserPeriodMetrics = {
	activeUsers: number
	activeIdentifiedUsers: number
	newUsers: number
	churnedUsers: number
}
export type UserAnalyticsOverviewResponse = {
	currentPeriod: UserPeriodMetrics
	previousPeriod: UserPeriodMetrics
	comparisonRange: ComparisonRange
	hasComparison: boolean
}
export type UserOverTimeDataPoint = {
	date: string
	activeUsers: number
	activeIdentifiedUsers: number
	newUsers: number
	churnedUsers: number
	partial: boolean
}
export type UserAnalyticsResponse = {
	overview: UserAnalyticsOverviewResponse
	usersOverTime: UserOverTimeDataPoint[]
	periodStart: number
	periodEnd: number
	isCurrentPeriod: boolean
}
export const RevenueReportGroupBy = {
	Hour: 'hour',
	Day: 'day',
	Week: 'week',
	Month: 'month'
} as const
export type RevenueReportGroupByType = (typeof RevenueReportGroupBy)[keyof typeof RevenueReportGroupBy]
export type RevenueReportResponse = {
	groupBy: RevenueReportGroupByType
	rows: RevenueOverTimeDataPoint[]
	comparisonRows?: RevenueOverTimeDataPoint[]
	totals: PeriodMetrics
	comparisonTotals: PeriodMetrics
	comparisonRange: ComparisonRange
	currencyCode: string
	hasComparison: boolean
	periodStart: number
	periodEnd: number
	isCurrentPeriod: boolean
}
export const ProductReportSortField = {
	Revenue: 'revenue',
	Quantity: 'quantity',
	Ordercount: 'orderCount'
} as const
export type ProductReportSortFieldType = (typeof ProductReportSortField)[keyof typeof ProductReportSortField]
export type ProductReportMetrics = {
	revenue: CommonTypes.Amount
	quantity: number
	orderCount: number
}
export type ProductReportRow = {
	productUuid: string
	productTitle: string
	imageUrl: string | null
	revenue: CommonTypes.Amount
	quantity: number
	orderCount: number
	revenueShare: number
	comparison?: ProductReportMetrics
}
export type ProductReportResponse = {
	rows: ProductReportRow[]
	totalCount: number
	totals: ProductReportMetrics
	comparisonTotals?: ProductReportMetrics
	comparisonRange: ComparisonRange
	currencyCode: string
	hasComparison: boolean
	periodStart: number
	periodEnd: number
	isCurrentPeriod: boolean
}

export const zAnalyticsInterval = z.enum(['day', 'week', 'month', 'quarter', 'year'])
export const zPeriodMetrics = z.object({
	revenue: CommonTypes.zAmount,
	orderCount: z.number(),
	averageOrderValue: CommonTypes.zAmount,
	refundTotal: CommonTypes.zAmount,
	refundCount: z.number()
})
export const zComparisonRange = z.object({
	from: z.number(),
	to: z.number()
})
export const zAnalyticsOverviewResponse = z.object({
	currentPeriod: zPeriodMetrics,
	previousPeriod: zPeriodMetrics,
	comparisonRange: zComparisonRange,
	currencyCode: z.string(),
	hasComparison: z.boolean()
})
export const zRevenueOverTimeDataPoint = z.object({
	date: z.string(),
	revenue: CommonTypes.zAmount,
	orderCount: z.number(),
	averageOrderValue: CommonTypes.zAmount,
	refundTotal: CommonTypes.zAmount,
	partial: z.boolean()
})
export const zTopProductItem = z.object({
	productUuid: z.string(),
	productTitle: z.string(),
	imageUrl: z.string().nullable(),
	revenue: CommonTypes.zAmount,
	quantity: z.number(),
	orderCount: z.number()
})
export const zPaymentMethodItem = z.object({
	method: z.string(),
	cardType: z.string().nullable(),
	amount: CommonTypes.zAmount,
	count: z.number(),
	percentage: z.number()
})
export const zSalesChannelItem = z.object({
	salesChannelUuid: z.string().nullable(),
	name: z.string(),
	revenue: CommonTypes.zAmount,
	orderCount: z.number()
})
export const zPointOfSaleItem = z.object({
	pointOfSaleUuid: z.string().nullable(),
	name: z.string(),
	revenue: CommonTypes.zAmount,
	orderCount: z.number()
})
export const zSalesByChannelResponse = z.object({
	channels: z.array(zSalesChannelItem),
	pointsOfSale: z.array(zPointOfSaleItem)
})
export const zHourlyDistributionItem = z.object({
	hour: z.number(),
	orderCount: z.number(),
	revenue: CommonTypes.zAmount
})
export const zCategoryItem = z.object({
	categoryUuid: z.string().nullable(),
	categoryName: z.string(),
	revenue: CommonTypes.zAmount,
	orderCount: z.number(),
	percentage: z.number()
})
export const zAnalyticsResponse = z.object({
	overview: zAnalyticsOverviewResponse,
	revenueOverTime: z.array(zRevenueOverTimeDataPoint),
	comparisonOverTime: z.array(zRevenueOverTimeDataPoint).optional(),
	topProducts: z.array(zTopProductItem),
	topProductsByQuantity: z.array(zTopProductItem),
	paymentMethods: z.array(zPaymentMethodItem),
	salesByChannel: zSalesByChannelResponse,
	hourlyDistribution: z.array(zHourlyDistributionItem),
	categories: z.array(zCategoryItem),
	periodStart: z.number(),
	periodEnd: z.number(),
	isCurrentPeriod: z.boolean(),
	channelFilterActive: z.boolean()
})
export const zBasketPairSortField = z.enum(['coOccurrenceCount', 'support', 'confidence', 'lift'])
export const zBasketSortOrder = z.enum(['asc', 'desc'])
export const zBasketOverviewPeriod = z.object({
	avgItemsPerOrder: z.number(),
	avgUniqueProductsPerOrder: z.number(),
	orderCount: z.number()
})
export const zBasketOverviewResponse = z.object({
	currentPeriod: zBasketOverviewPeriod,
	previousPeriod: zBasketOverviewPeriod,
	comparisonRange: zComparisonRange
})
export const zProductPairItem = z.object({
	productAUuid: z.string(),
	productATitle: z.string(),
	productAImageUrl: z.string().nullable(),
	productBUuid: z.string(),
	productBTitle: z.string(),
	productBImageUrl: z.string().nullable(),
	coOccurrenceCount: z.number(),
	support: z.number(),
	confidence: z.number(),
	lift: z.number()
})
export const zCategoryPairItem = z.object({
	categoryAUuid: z.string().nullable(),
	categoryAName: z.string(),
	categoryBUuid: z.string().nullable(),
	categoryBName: z.string(),
	coOccurrenceCount: z.number(),
	support: z.number(),
	confidence: z.number(),
	lift: z.number()
})
export const zBasketAnalysisResponse = z.object({
	overview: zBasketOverviewResponse,
	productPairs: z.array(zProductPairItem),
	categoryPairs: z.array(zCategoryPairItem)
})
export const zUserPeriodMetrics = z.object({
	activeUsers: z.number(),
	activeIdentifiedUsers: z.number(),
	newUsers: z.number(),
	churnedUsers: z.number()
})
export const zUserAnalyticsOverviewResponse = z.object({
	currentPeriod: zUserPeriodMetrics,
	previousPeriod: zUserPeriodMetrics,
	comparisonRange: zComparisonRange,
	hasComparison: z.boolean()
})
export const zUserOverTimeDataPoint = z.object({
	date: z.string(),
	activeUsers: z.number(),
	activeIdentifiedUsers: z.number(),
	newUsers: z.number(),
	churnedUsers: z.number(),
	partial: z.boolean()
})
export const zUserAnalyticsResponse = z.object({
	overview: zUserAnalyticsOverviewResponse,
	usersOverTime: z.array(zUserOverTimeDataPoint),
	periodStart: z.number(),
	periodEnd: z.number(),
	isCurrentPeriod: z.boolean()
})
export const zRevenueReportGroupBy = z.enum(['hour', 'day', 'week', 'month'])
export const zRevenueReportResponse = z.object({
	groupBy: zRevenueReportGroupBy,
	rows: z.array(zRevenueOverTimeDataPoint),
	comparisonRows: z.array(zRevenueOverTimeDataPoint).optional(),
	totals: zPeriodMetrics,
	comparisonTotals: zPeriodMetrics,
	comparisonRange: zComparisonRange,
	currencyCode: z.string(),
	hasComparison: z.boolean(),
	periodStart: z.number(),
	periodEnd: z.number(),
	isCurrentPeriod: z.boolean()
})
export const zProductReportSortField = z.enum(['revenue', 'quantity', 'orderCount'])
export const zProductReportMetrics = z.object({
	revenue: CommonTypes.zAmount,
	quantity: z.number(),
	orderCount: z.number()
})
export const zProductReportRow = z.object({
	productUuid: z.string(),
	productTitle: z.string(),
	imageUrl: z.string().nullable(),
	revenue: CommonTypes.zAmount,
	quantity: z.number(),
	orderCount: z.number(),
	revenueShare: z.number(),
	comparison: zProductReportMetrics.optional().nullable()
})
export const zProductReportResponse = z.object({
	rows: z.array(zProductReportRow),
	totalCount: z.number(),
	totals: zProductReportMetrics,
	comparisonTotals: zProductReportMetrics.optional().nullable(),
	comparisonRange: zComparisonRange,
	currencyCode: z.string(),
	hasComparison: z.boolean(),
	periodStart: z.number(),
	periodEnd: z.number(),
	isCurrentPeriod: z.boolean()
})
